import { API } from 'utils';

import { AuditEventResponse, RegisterEventPayload } from './auditEvents.model';

const effects = () => ({
  async registerEvent({ agreementId, eventName }: RegisterEventPayload) {
    const url = `/audit/event/${agreementId}?actionName=${eventName}`;
    return API.post<undefined, AuditEventResponse>(url, undefined, true)
      .then((response) => response)
      .catch(() => undefined);
  }
});

export default effects;
